import type { GetPrizesElementResponseType } from "@jti/rest-api-types";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

type TrackRedeemCheckoutParams = {
  name?: GetPrizesElementResponseType["name"];
  locations?: GetPrizesElementResponseType["locations"] | null;
};

export const trackRedeemCheckout = ({ name, locations }: TrackRedeemCheckoutParams) => {
  return dispatchTrackingEvent(TrackingEvents.TrackingRedeemCheckout, {
    reward: name ?? "",
    sensory_experience: (locations?.length ?? 0) > 0,
  });
};
